
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    termsAndConditions: {
      type: Array,
      default: () => [],
    },
    modalTitle: {
      type: String,
      default: "",
    },
    buttonLabel: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "",
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    handleJoinMemberClick() {
      this.close();
      this.$emit("join-member");
    },
  },
};
